'use client'

import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import {
  AuthenticatedTemplate,
  useMsal,
  UnauthenticatedTemplate,
  useMsalAuthentication
} from "@azure/msal-react"
import { ServiceCoursesProvider } from 'api/ServiceCoursesProvider'
import { useLanguage } from 'contexts/LanguageContext'
import Spinner from 'components/spinner'
import { InteractionType, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from 'AuthConfig';

export default function Invitation() {
  let { invitation } = useParams<{ invitation: string }>();
  const { lang, res } = useLanguage();
  const navigate = useNavigate();
  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  let enErreur = false;
  const [loading, setLoading] = useState(true)

  invitation = invitation ?? "";

  let erreur = <div />
  if (invitation == "") {
    erreur = <div>{res["Code d'invitation pas trouvé"]}</div>;
    enErreur = true;
  }

  if (!guidRegex.test(invitation)) {
    erreur = <div>{res["Code d'invitation pas trouvé"]}</div>;
    enErreur = true;
  }

  const [erreurDiv, setErreurDiv] = useState(erreur);
  const [enErreurFlag, setEnErreur] = useState(enErreur);
  const {login, result, error} = useMsalAuthentication(InteractionType.Popup);
  const {instance} = useMsal();

  function signInClickHandler(instance: IPublicClientApplication) {
    // Open B2C login with a redirect 
    loginRequest.extraQueryParameters = {
      ui_locales: lang === 'fr' ? "fr-ca" : 'en-ca' // Change this to the desired locale
    };
    instance.loginRedirect(loginRequest)
    // another method could open that with a popup window 
    // instance.loginPopup(loginRequest)
  }

  function UserAuthenticated({ invitation }: { invitation: string }) {
    const msal = useMsal();

    useEffect(() => {
      const updateSubscription = async () => {
        try {
          const updateRes = await ServiceCoursesProvider.provider.updateSubscription(msal, lang, invitation);
          // Si l'erreur est 403, c'est une erreur de validation
          if (updateRes.status === 403) {
            const errorArr = (updateRes && updateRes.data) ? updateRes.data.split("\r\n") : []

            let erreur = <div className="messageWrap" style={{marginTop: "10px"}}>
                  {res["Erreur de validation !"] }
                  {errorArr.map((err: keyof typeof res["InvitationValidationsErr"], errInd: number) => (
                      <div key={"errorLine"+errInd}>--{res.InvitationValidationsErr[err]}</div>
                  ))}
              </div>;
            
            setEnErreur(true);
            setErreurDiv(erreur);
          } else {
            setLoading(false);
            setTimeout(() => {
              navigate(`/${lang}/`);
            }, 1000)
          }
        
        } catch (e) { 
          let erreur = <div>{res["Erreur generique"]}</div>;
          setEnErreur(true);
          setErreurDiv(erreur);
        }
        
      };

      updateSubscription();
    }, [msal]);

    return <div>{res["La connexion est établie."]}
       {(loading) ? (
            <Spinner />
          ) : null }
    </div>;
  }

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
        <div className="relative pt-32 pb-10">
          <div className="_max-w-3xl mx-auto _text-center">
            {enErreurFlag ?
              erreurDiv
              :
              <>
                <AuthenticatedTemplate>
                  <div className="messageWrap" style={{ background: "#dff6dd" }}>
                    Invitation: {invitation}
                  </div>
                  <UserAuthenticated invitation={invitation} />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <section>
                    <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
                      <div className="relative pt-32 pb-10 md:pb-16">
                        <div className="messageWrap">
                          {res["Connexion Obligatoire Invitation"]}
                          <button onClick={() => signInClickHandler(instance)} className="btn-sm text-white bg-gray-700 hover:bg-gray-800 ml-3">
                            {res["Me connecter"]}
                          </button>
                        </div>
                      </div>
                    </div>
                  </section>
                </UnauthenticatedTemplate>
              </>
            }
          </div>
        </div>

      </div>
    </section>
  )
}
